"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useTranslation_1 = __importDefault(require("./useTranslation"));
var i18nProvider_1 = require("./i18nProvider");
var Translate = function (translationKey, params) {
    var translation = (0, useTranslation_1.default)();
    var translate = function (id) { return translation({ id: id }); };
    var translatedString = translationKey ? translate(translationKey) : '';
    var customBrandName = (0, react_1.useContext)(i18nProvider_1.CustomBrandNameContext);
    params &&
        Object.entries(params).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var param = "{".concat(key, "}");
            if (translatedString.includes(param))
                translatedString = translatedString.replace(param, value);
        });
    var re = /Codebashing|codebashing|CodeBashing/gi;
    if (customBrandName && translatedString.toLowerCase().includes('codebashing')) {
        translatedString = translatedString.replace(re, customBrandName);
    }
    return translatedString;
};
exports.default = Translate;
